import axios from 'axios';
import { getBaseURL } from 'utils/environment';

export const spoApi = axios.create({
  baseURL: `https://api-spo.${getBaseURL()}/`,
});

// Add a request interceptor
spoApi.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
spoApi.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return { status: 'SUCCESS', data: response?.data };
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return { status: 'ERROR', errorMessage: error?.response?.data?.message };
    // return Promise.reject(error);
  },
);
